var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1C3.91579 1 1 3.91579 1 7.5C1 11.0842 3.91579 14 7.5 14H14V7.5C14 3.91579 11.0842 1 7.5 1ZM13.4583 13.4583H7.5C4.21479 13.4583 1.54167 10.7852 1.54167 7.5C1.54167 4.21479 4.21479 1.54167 7.5 1.54167C10.7852 1.54167 13.4583 4.21479 13.4583 7.5V13.4583ZM8.04167 7.5C8.04167 7.799 7.799 8.04167 7.5 8.04167C7.201 8.04167 6.95833 7.799 6.95833 7.5C6.95833 7.201 7.201 6.95833 7.5 6.95833C7.799 6.95833 8.04167 7.201 8.04167 7.5ZM10.75 7.5C10.75 7.799 10.5073 8.04167 10.2083 8.04167C9.90933 8.04167 9.66667 7.799 9.66667 7.5C9.66667 7.201 9.90933 6.95833 10.2083 6.95833C10.5073 6.95833 10.75 7.201 10.75 7.5ZM5.33333 7.5C5.33333 7.799 5.09067 8.04167 4.79167 8.04167C4.49267 8.04167 4.25 7.799 4.25 7.5C4.25 7.201 4.49267 6.95833 4.79167 6.95833C5.09067 6.95833 5.33333 7.201 5.33333 7.5Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.49053bfd81ac59839bed5cb04e527459.svg";
export { ForwardRef as ReactComponent };